import { List } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AccountData } from '../../../../api';
import { useAuth } from '../../../../session/InternalAuthProvider';
import { FilterMenu } from '../../../../common/filter/FilterMenu';
import { WorkshopsFilterSection } from '../../../../common/filter/WorkshopsFilterSection';
import { LocationsFilterSection } from '../../../../common/filter/LocationsFilterSection';
import { CheckboxGroupSection } from '../../../../common/filter/CheckboxGroupSection';
import { SectionType, getVisibleSectionTypes } from '../../sectionMeta';
import { useAnalyticsFilter } from './AnalyticsFilterContext';
import { useAnalyticsFilterSummary } from './useAnalyticsFilterSummary';

export const AnalyticsFilter = () => {
  const { t } = useTranslation();
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;
  const summary = useAnalyticsFilterSummary();
  const {
    selectedLocationIds,
    setSelectedLocationIds,
    selectedOrderPageIds,
    setSelectedOrderPageIds,
    sectionTypes,
    setSectionTypes,
    isFilterActive,
    resetFilter,
  } = useAnalyticsFilter();

  return (
    <FilterMenu
      name="Analytics"
      isActive={isFilterActive}
      summaryLabel={summary.primary}
      secondaryLabel={summary.secondary}
      onReset={resetFilter}>
      <List disablePadding>
        <LocationsFilterSection
          account={account}
          selectedLocationIds={selectedLocationIds}
          onChange={setSelectedLocationIds}
        />
        <CheckboxGroupSection<SectionType>
          title={t('analytics.filter.sections')}
          items={getVisibleSectionTypes(account)}
          itemLabel={(s) => t(`analytics.sections.${s}.title`)}
          selected={sectionTypes}
          onChange={setSectionTypes}
        />
        <WorkshopsFilterSection
          hideLocations
          account={account}
          selectedIds={selectedOrderPageIds}
          onChange={setSelectedOrderPageIds}
        />
      </List>
    </FilterMenu>
  );
};
